<template>
  <section class="wrapper-messages-area">
    <b-loading isFullPage :active="isLoading" />
    <div class="columns">
      <h1 class="title column is-size-5 has-text-color-7 mb-0">
        {{ App.MessagesAreaScreen.SEND_MESSAGE }}
      </h1>
    </div>

    <ValidationObserver v-slot="{ handleSubmit }" tag="section">
      <TimelineItem
        :title="`Dados da mensagem`"
        stepValue="1"
        statusSize="large"
        statusColor="success"
      >
        <ValidationProvider v-slot="{ errors }" rules="required" tag="div">
          <b-field :type="errors.length ? 'is-refused' : ''">
            <template #label>
              <span class="has-text-weight-semibold has-text-color-7">
                {{ App.MessagesAreaScreen.MESSAGE_TITLE }}
              </span>
            </template>
            <b-input
              v-model="messageTitle"
              :placeholder="
                App.MessagesAreaScreen.PLACEHOLDER.TYPE_MESSAGE_TITLE
              "
              maxlength="100"
            />
            <template #message>
              <ErrorField :errors="errors" />
            </template>
          </b-field>
        </ValidationProvider>

        <ValidationProvider v-slot="{ errors }" rules="required" tag="div">
          <b-field :type="errors.length ? 'is-refused' : ''">
            <template #label>
              <span class="has-text-weight-semibold has-text-color-7">
                {{ App.MessagesAreaScreen.MESSAGE }}
              </span>
            </template>
            <b-input
              v-model="description"
              :placeholder="App.MessagesAreaScreen.PLACEHOLDER.TYPE_MESSAGE"
              maxlength="1000"
              type="textarea"
            />
            <template #message>
              <ErrorField :errors="errors" />
            </template>
          </b-field>
        </ValidationProvider>
      </TimelineItem>
      <div class="buttons custom-margin my-10">
        <b-button
          class="has-text-weight-semibold"
          :type="isContrast ? 'is-white-dark' : 'is-green-lawn'"
          :disabled="!validMessage"
          @click.stop="handleSubmit(submitMessage)"
        >
          {{ General.SUBMIT }}
        </b-button>
        <b-button
          class="has-text-weight-semibold"
          :type="isContrast ? 'is-white-dark' : 'is-warning'"
          outlined
          @click.stop="cancel"
        >
          {{ General.CANCEL }}
        </b-button>
      </div>
    </ValidationObserver>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { App, General } from "@/utils/constants";

import TimelineItem from "@/components/TimelineItem";

export default {
  name: "SendMessage",

  components: {
    TimelineItem
  },

  data() {
    return {
      App,
      General,
      isLoading: false,
      messageTitle: "",
      description: ""
    };
  },

  computed: {
    ...mapGetters({
      isContrast: "isContrast"
    }),

    validMessage() {
      return Boolean(this.messageTitle.length && this.description.length);
    }
  },

  methods: {
    ...mapActions({
      sendMessage: "sendMessage"
    }),

    async submitMessage() {
      this.isLoading = true;
      await this.sendMessage({
        title: this.messageTitle,
        description: this.description
      });
      this.isLoading = false;
      this.$router.push("/app/admin/mensagens");
    },

    cancel() {
      this.$router.push("/app/admin/mensagens");
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables";

.wrapper-messages-area {
  background-color: $color-1;
  padding: 20px;
}

.custom-margin {
  margin-left: 67.5px;
}
</style>
